import { secretDecode, secretEncode } from "./hashSecretCode";

const USER_PROFILE = "USER_PROFILE";
const AUTH_TOKEN = "AUTH_TOKEN";

// ========= AUTH_TOKEN =========
export const setLocalStorageAuth = ({ authToken }) => {
  const hashToken = secretEncode({ jwtData: authToken });
  localStorage.setItem(AUTH_TOKEN, hashToken);
};

export const getLocalStorageAuth = () => {
  try {
    const hashToken = localStorage.getItem(AUTH_TOKEN);
    const userToken = hashToken
      ? secretDecode({ jwtData: hashToken })
      : undefined;
    return userToken;
  } catch (error) {
    console.log("error in getLocalStorageAuth :>> ", error);
    clearLocalStorageAuth();
    // window.location.replace("/");
  }
};

export const clearLocalStorageAuth = () => {
  return localStorage.removeItem(AUTH_TOKEN);
};
// ========= AUTH_TOKEN =========

// ======== USER_PROFILE =========
export const setLocalStorageUserProfile = ({ userProfile }) => {
  const hashToken = secretEncode({ jwtData: userProfile });
  localStorage.setItem(USER_PROFILE, hashToken);
};

export const getLocalStorageUserProfile = () => {
  try {
    const hashToken = localStorage.getItem(USER_PROFILE);
    const userProfile = hashToken
      ? secretDecode({ jwtData: hashToken })
      : undefined;
    return userProfile;
  } catch (error) {
    console.log("error in getLocalStorageUserProfile :>> ", error);
    clearLocalStorageAuth();
    window.location.replace("/");
  }
};

export const clearLocalStorageProfile = () => {
  return localStorage.removeItem(USER_PROFILE);
};
// ======== USER_PROFILE =========
